import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from '@store/app.reducer';
import { heightExpanded, valueExpanded } from './expandable-group.actions';

@Injectable({
  providedIn: 'root',
})
export class ExpandableGroupService {
  constructor(private store: Store<AppState>) {}

  setHeight(nameGroup: string, height: number) {
    this.store.dispatch(heightExpanded({ nameGroup: nameGroup, height: height }));
  }

  setExpanded(nameGroup: string, value: boolean) {
    this.store.dispatch(valueExpanded({ nameGroup: nameGroup, value: value }));
  }

  listenChange() {
    return this.store.select('groupExpandable');
  }
}
